import { Component, Input } from '@angular/core';

import { VideogularComponent } from './videogular/Videogular.Component';

import { PlaybackOption } from './PlaybackOption';
import { SupportedPlaybacksService } from './SupportedPlaybacks.Service';
import { VBrickPlayerComponent } from './VbrickPlayer.Component';
import { VbPlaybackManagerComponent } from './VbPlaybackManager.Component';

import styles from './VbPlaybackMenuButton.module.less';
import { VbNestedMenuComponent } from './shared/VbNestedMenuComponent';

@Component({
	selector: 'vb-playback-menu-button',
	host: {
		'[class]': 'styles.menuButtonContainer'
	},
	template: `
		<div
			[ngClass]="styles.dropdown"
			dropdown
			#dropdown="bs-dropdown"
			placement="top right"
			[dropup]="true"
			[autoClose]="true"
			[hidden]="playbackManager.supportedPlaybackOptions.length <= 1">

			<ul
				[ngClass]="styles.dropdownMenu"
				class="playerSettingsSubmenu"
				*dropdownMenu
				#vbDropdownMenu
				aria-labelledby="buttonMenuPlaybackSource"
				id="dropdownPlaybackSourceMenu"
				role="menu"
				tabindex="0">
				<li role="none">
					<button type="button"
						role="menuitem"
						class="dropdown-item btn-link"
						[ngClass]="styles.backToMainMenuItem"
						(click)="hideMenu()">
						<span>{{ translations.playbackSource }}</span>
					</button>
				</li>
				<li role="none" class="divider dropdown-divider"></li>
				<li role="none"
					*ngFor="let playbackOption of playbackManager.supportedPlaybackOptions; trackBy: playbackOptionsTrackByFunc">
					<button type="button"
						role="menuitem"
						class="dropdown-item btn-link"
						[ngClass]="isPlaybackSelected(playbackOption) ? styles.selected : ''"
						(click)="onMenuItemClick(playbackOption)">
						{{ playbackOption.label }}
					</button>
				</li>
			</ul>
		</div>`,
    standalone: false
})
export class VbPlaybackMenuButtonComponent extends VbNestedMenuComponent {
	@Input() public translations: any;
	@Input() public playbackManager: VbPlaybackManagerComponent;

	public readonly styles = { ...this.menuButtonStyles, ...styles };

	constructor(
		private supportedPlaybacks: SupportedPlaybacksService,
		private vgApi: VideogularComponent
	) {
		super();
	}

	public isPlaybackSelected(playbackOption: PlaybackOption): boolean {
		return this.vgApi.activeSource && this.vgApi.activeSource.label === playbackOption.label;
	}

	public onMenuItemClick(playbackOption: PlaybackOption): void {
		if (this.isPlaybackSelected(playbackOption)) {
			return;
		}

		this.playbackManager.onManualStreamSwitch.emit({
			src: playbackOption.src,
			isFlash: this.supportedPlaybacks.getIsFlashPlayback(playbackOption, this.vgApi.flashDisabled, this.vgApi),
			playback: playbackOption
		});

		this.playbackManager.updateSelection(playbackOption);
		this.hideMenu();
	}

	public playbackOptionsTrackByFunc(_index: number, playbackOption: PlaybackOption): string {
		return playbackOption.src;
	}
}
